/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'navigation.global-shortcuts.all-sites': 'すべてのサイト',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': '閉じる',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(現在利用できません)',
};
